import { useEffect, useState } from "react";
import { jwtFetch } from "./utils/apiClient";
import { useParams, useNavigate } from "react-router-dom";
import Menu from "./Components/Menu";
import Header from "./Components/Header";
import { config, priceFormat, shortenUrl } from "./Components/Config";
import { format, addMonths, subDays } from "date-fns";

const AttainmentDetail = () => {
  const { id_attainment } = useParams();
  const [attainment, setAttainment] = useState(null);
  const [attainmentItems, setAttainmentItems] = useState(null);
  const [quotation, setQuotation] = useState(null);
  const [quotationItems, setQuotationItems] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();

  const crmUser = JSON.parse(localStorage.getItem('crmUser'));

  useEffect(() => {
    if (id_attainment) {
      getAttainment();
      getAttainmentItems();
    }
  }, [id_attainment]);

  useEffect(() => {
    if (attainment) {
      getQuotation();
    }
  }, [attainment]);

  const getAttainment = async () => {
    try {
      const fetchAttainment = await jwtFetch(config.ENDPOINT + 'get/attainment', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_attainment: id_attainment
        })
      });
      const responseAttainment = await fetchAttainment.json();
      if (responseAttainment.status === 200) {
        setAttainment(responseAttainment.data[0]);
      } else {
        alert(responseAttainment.message);
      }
    } catch (error) {
      console.error('Error in getAttainment:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getAttainmentItems = async () => {
    try {
      const fetchGetAttainmentItems = await jwtFetch(config.ENDPOINT + 'get/attainment_item', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          attainment_id: id_attainment
        })
      });
      const responseGetAttainmentItems = await fetchGetAttainmentItems.json();
      if (responseGetAttainmentItems.status === 200) {
        setAttainmentItems(responseGetAttainmentItems.data);
      } else {
        alert(responseGetAttainmentItems.message);
      }
    } catch (error) {
      console.error('Error in getAttainmentItems:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const getQuotation = async () => {
    try {
      const fetchQuotation = await jwtFetch(config.ENDPOINT + 'get/quotation', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_quotation: attainment.quotation_id
        })
      });
      const responseGetQuotation = await fetchQuotation.json();
      if (responseGetQuotation.status === 200) {
        setQuotation(responseGetQuotation.data[0]);
        let itemList = [];
        for (let i in responseGetQuotation.data[0].quotation_item_list) {
          itemList.push(responseGetQuotation.data[0].quotation_item_list[i]);
        }
        setQuotationItems(itemList);
      } else {
        alert(responseGetQuotation.message);
      }
    } catch (error) {
      console.error('Error in getQuotation:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  const copyItem = (itemIndex) => {
    let description = quotationItems[itemIndex].product_display_name;
    description += '\n\n';
    description += quotationItems[itemIndex].product_display_description;
    description += '\n\n';
    navigator.clipboard.writeText(description);
  }

  const editAttainment = async (status) => {
    try {
      const fetchEditAttainment = await jwtFetch(config.ENDPOINT + 'update/attainment', {
        method: 'POST',
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          id_attainment: id_attainment,
          attainment_status: status,
        })
      });
      const responseEditAttainment = await fetchEditAttainment.json();
      if (responseEditAttainment.status === 200) {
        window.location.reload();
      } else {
        alert(responseEditAttainment.message);
      }
    } catch (error) {
      console.error('Error in editAttainment:', error);
      alert('An error occurred: ' + (error.message || error));
    }
  };

  return (
    <div id="attainment-detail">
      <div className="container-fluid p-0">
        <div className="row g-0 mh-100vh">
          <div className="col-md-2 border-end">
            <div className="d-md-flex d-none align-items-center justify-content-center p-1 h-48">
              <a className="h-100" href="/dashboard"><img className="h-100" src="/cuancuan.png" alt="PointStar" /></a>
            </div>
            <hr className="m-0" />
            <Menu active="attainment" />
          </div>
          <div className="col-md-10">
            <Header />
            <hr className="m-0" />
            <div className="main">
              <div className="p-4">
                {attainment && (
                  <div className="mb-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="d-flex align-items-center">
                        <div className="fs-24"><button className="btn btn-link" onClick={() => navigate(-1)}><i className="bi bi-arrow-left" /></button> Attainment Detail</div>
                        {(
                          () => {
                            const statusStyles = {
                              'Submitted': 'secondary',
                              'Approved': 'success',
                              'Rejected': 'danger',
                              'Canceled': 'danger'
                            };
                            const style = statusStyles[attainment.attainment_status];
                            return style && (
                              <span className={"badge badge-sm ms-3 text-bg-" + style}>{attainment.attainment_status}</span>
                            );
                          }
                        )()}
                      </div>
                      <div className="d-flex align-items-center justify-content-between gap-2">
                        {crmUser.user_level !== 'View' && (
                          <>
                            {attainment.attainment_status === 'Submitted' && crmUser.user_level === 'Admin' && (
                              <>
                                <button className="btn btn-sm btn-outline-success" onClick={() => editAttainment('Approved')} disabled={isLoading}><i className="bi bi-check-lg me-2" /> Approve</button>
                                <button className="btn btn-sm btn-outline-danger" onClick={() => editAttainment('Rejected')} disabled={isLoading}><i className="bi bi-x-circle me-2" /> Reject</button>
                              </>
                            )}
                            {(crmUser.user_role_division === 'Head' || attainment.user_role_division === 'Manager') && (
                              <>
                                {
                                  (attainment.attainment_status === 'Submitted' && crmUser.user_level === 'User') && (
                                    <>
                                      <button className="btn btn-sm btn-outline-danger" onClick={() => editAttainment('Canceled')}><i className="bi bi-x-circle me-2" /> Cancel</button>
                                      <a className="btn btn-sm btn-outline-secondary" href={"/attainment/edit/" + id_attainment}><i className="bi bi-pencil me-2" /> Edit</a>
                                    </>
                                  )
                                }
                                {attainment.attainment_status === 'Rejected' && crmUser.user_level === 'User' && (
                                  <a className="btn btn-sm btn-outline-secondary" href={"/attainment/edit/" + id_attainment}><i className="bi bi-pencil me-2" /> Edit</a>
                                )}
                              </>
                            )}
                          </>
                        )}
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-6">
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Number</div>
                          <div className="col-md-8">{attainment.attainment_code} <i className="bi bi-copy pointer" onClick={() => navigator.clipboard.writeText(attainment.attainment_code)} /></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Company Group</div>
                          <div className="col-md-8">{attainment.company_name} <a href={`/client/detail/${attainment.company_id}`}><i className="bi bi-link-45deg" /></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Subsidiary</div>
                          <div className="col-md-8">{attainment.subcompany_name} <a href={`/client/subsidiary/detail/${attainment.subcompany_id}`}><i className="bi bi-link-45deg" /></a></div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Amount</div>
                          <div className="col-md-8">{priceFormat(attainment.attainment_total, 'IDR')}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Quarter</div>
                          <div className="col-md-8">{"Q" + attainment.target_quarter + ' ' + attainment.target_year}</div>
                        </div>
                        <div className="row mb-2">
                          <div className="col-md-4 text-secondary">Sales Name</div>
                          <div className="col-md-8">{attainment.sales_name}</div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        {quotation && (
                          <div className="card mb-2">
                            <div className="card-body">
                              <div className="d-flex align-items-center justify-content-between">
                                <p className="fs-14 mb-0"><strong>Quotation</strong></p>
                                <a href={"/quotation/detail/" + quotation.id_quotation}>{quotation.quotation_code} <i className="bi bi-link-45deg ms-1" /></a>
                              </div>
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}

                {quotation && (
                  <div className="mb-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="fs-24">SKU List</div>
                    </div>
                    <div className="bg-white border-radius-4 p-4">
                      <div className="table-responsive">
                        <table className="table table-hover bordered mb-0">
                          <thead>
                            <tr>
                              <th className="bg-gold w-30">#</th>
                              <th className="bg-gold">SKUs</th>
                              <th className="bg-gold w-85">Period</th>
                              <th className="bg-gold w-85">Qty</th>
                              <th className="bg-gold w-105">Cost Price / Unit</th>
                              <th className="bg-gold w-105">Sell Price / Unit</th>
                              <th className="bg-gold w-105">Discount</th>
                              <th className="bg-gold w-125">Amount</th>
                            </tr>
                          </thead>
                          <tbody>
                            {quotation.quotation_item_list && quotation.quotation_item_list.map((item, i) => {
                              return (
                                <tr className={item.product_total === 0 ? 'd-none' : ''} key={i}>
                                  <td valign="middle" align="center">{i + 1}</td>
                                  <td valign="middle">
                                    <div className="d-flex align-items-center justify-content-between mb-2">
                                      <p className="mb-0"><strong>{item.product_display_name}</strong></p>
                                      <button className="btn btn-sm btn-outline-secondary" onClick={() => copyItem(i)}><i className="bi bi-copy" /></button>
                                    </div>
                                    {item.product_display_description && item.product_display_description.split('\n').map((description, d) => (
                                      <div className="row mb-1" key={"description-" + d}>
                                        {description.split(':').length > 1 ? (
                                          <div className="col-4">{description.split(':')[0].trim()}</div>
                                        ) : (
                                          <div className="col-12">{description.trim()}</div>
                                        )}
                                        {description.split(':').length > 1 && (
                                          <div className="col-8">
                                            <div className="d-flex">
                                              <span className="me-2">:</span>
                                              <div>{description.split(':').slice(1).join(':').trim()}</div>
                                            </div>
                                          </div>
                                        )}
                                      </div>
                                    ))}
                                  </td>
                                  <td valign="middle" align="center">
                                    {
                                      item.product_type === 'Subscription' ? (
                                        (item.contract_long_period + " " + (item.contract_long_period > 1 ? ' Months' : ' Month'))
                                      ) : 'N/A'
                                    }
                                  </td>
                                  <td valign="middle" align="center">{item.product_qty + ' Unit(s)'}</td>
                                  <td valign="middle" align="center">
                                    <div className="d-flex flex-column justify-content-between py-3">
                                      <span>{priceFormat(item.product_cost, item.product_currency)}</span>
                                      {item.product_currency !== item.product_currency_original && (<hr className="my-3" />)}
                                      {item.product_currency !== item.product_currency_original && (<span className="text-secondary">{priceFormat(item.product_cost_original, item.product_currency_original)}</span>)}
                                    </div>
                                  </td>
                                  <td valign="middle" align="center">
                                    <div className="d-flex flex-column justify-content-between py-3">
                                      <span>{priceFormat(item.product_price, item.product_currency)}</span>
                                      {item.product_currency !== item.product_currency_original && (<hr className="my-3" />)}
                                      {item.product_currency !== item.product_currency_original && (<span className="text-secondary">{priceFormat(item.product_price_original, item.product_currency_original)}</span>)}
                                    </div>
                                  </td>
                                  <td valign="middle" align="center">
                                    {item.product_discount_price > 0 ? (
                                      <div className="d-flex flex-column justify-content-between py-3">
                                        <span className="text-danger">-{priceFormat(item.product_discount_price, item.product_currency)}</span>
                                        {item.product_discount_price > 0 && (<hr className="my-3" />)}
                                        {item.product_discount_price > 0 && (<span className="text-secondary">{priceFormat(item.product_discount_rate, "%")}</span>)}
                                      </div>
                                    ) : 'N/A'}
                                  </td>
                                  <td valign="middle" align="end">
                                    <span>{priceFormat(item.product_total, item.product_currency)}</span>
                                  </td>
                                </tr>
                              )
                            })}
                          </tbody>
                          <tfoot>
                            <tr>
                              <td className="text-end" colSpan={7}>
                                Subtotal
                                <br />
                                Discount on QT {quotation.quotation_discount_price > 0 ? (" (" + priceFormat(quotation.quotation_discount_rate) + "%)") : ""}
                                <br />
                                Total Before Tax
                              </td>
                              <td className="text-end">
                                {priceFormat(quotation.quotation_subtotal, quotation.quotation_currency)}
                                <br />
                                <span className="text-danger">{quotation.quotation_discount_price > 0 ? ("-" + priceFormat(quotation.quotation_discount_price, quotation.quotation_currency)) : "0"}</span>
                                <br />
                                <strong>{priceFormat(quotation.quotation_total, quotation.quotation_currency)}</strong>
                              </td>
                            </tr>
                          </tfoot>
                        </table>
                      </div>
                    </div>
                  </div>
                )}

                {attainment && (
                  <div className="mb-4">
                    <div className="d-flex align-items-center justify-content-between mb-3">
                      <div className="fs-24">Attainment</div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="row align-items-top form-group mb-2">
                          <div className="col-md-2">
                            <label>SKUs</label>
                          </div>
                          <div className="col-md-10">
                            <div className="">
                              <table className="table table-bordered mb-0">
                                <thead>
                                  <tr>
                                    <th className="bg-secondary text-light" style={{ textAlign: 'center' }}>#</th>
                                    <th className="bg-secondary text-light">Name</th>
                                    <th className="bg-secondary text-center text-light w-80">Period</th>
                                    <th className="bg-secondary text-center text-light w-80">Qty</th>
                                    <th className="bg-secondary text-center text-light w-300">Calculations</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {attainmentItems && attainmentItems.map((attainmentItem, a) =>
                                    <tr key={"attainment-" + a}>
                                      <td align="center">{a + 1}</td>
                                      <td>{attainmentItem.product_display_name}</td>
                                      <td>{attainmentItem.contract_long_period + " Month(s)"}</td>
                                      <td>{attainmentItem.product_qty + " Unit(s)"}</td>
                                      <td>
                                        <div className="row mb-2">
                                          <div className="col-md-6">Unit Cost</div>
                                          <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_cost, 'IDR')}</div>
                                        </div>
                                        <div className="row mb-4">
                                          <div className="col-md-6">Unit Price</div>
                                          <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_price, 'IDR')}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-md-6">Subtotal</div>
                                          <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_subtotal, 'IDR')}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-md-6">Discount</div>
                                          <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_discount_price, 'IDR')}</div>
                                        </div>
                                        <div className="row mb-3">
                                          <div className="col-md-6">Total</div>
                                          <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_total, 'IDR')}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-md-6">Cost</div>
                                          <div className="col-md-6 text-end">{priceFormat(attainmentItem.product_total - attainmentItem.product_margin_price, 'IDR')}</div>
                                        </div>
                                        <div className="row mb-2">
                                          <div className="col-md-6 strong">Margin</div>
                                          <div className="col-md-6 text-end strong">{priceFormat(attainmentItem.product_margin_price, 'IDR')}</div>
                                        </div>
                                      </td>
                                    </tr>
                                  )}
                                </tbody>
                                <tfoot>
                                  <tr>
                                    <td colSpan={5} className="bg-transparent">
                                      <div className="row mb-2">
                                        <div className="col-md-6 strong">Amount</div>
                                        <div className="col-md-6 text-end strong">{priceFormat(attainmentItems?.reduce((total, attainmentItem) => total + Number(attainmentItem.product_margin_price), 0), 'IDR')}</div>
                                      </div>
                                    </td>
                                  </tr>
                                </tfoot>
                              </table>
                            </div>
                          </div>
                        </div>
                        <div className="row align-items-baseline form-group mb-2">
                          <div className="col-md-2">
                            <label>Attainment Remarks</label>
                          </div>
                          <div className="col-md-10">{attainment.attainment_remarks}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AttainmentDetail;


